import { useEffect } from 'react';

import Cookies from 'js-cookie';

import { PREVIEW_COOKIE_NAME } from './eligibility';
import { SPLIT_TEST_NAME } from '../../AnonymousSplitTest/SPLIT_TESTS';

const PARAM_NAME = 'mobilePreview';
const SPLIT_COOKIE_NAME = `iw-${SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1}`;
const FORCED_SPLIT_COOKIE = JSON.stringify({
  test_name: SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1,
  branch_name: 'INCLUDE',
});

export const applyMobilePreviewOverride = (
  search: string,
): 'set' | 'cleared' | 'none' => {
  const value = new URLSearchParams(search).get(PARAM_NAME);

  if (value === 'true') {
    Cookies.set(PREVIEW_COOKIE_NAME, 'true');
    Cookies.set(SPLIT_COOKIE_NAME, FORCED_SPLIT_COOKIE);
    return 'set';
  }

  if (value === 'false') {
    Cookies.remove(PREVIEW_COOKIE_NAME);
    Cookies.remove(SPLIT_COOKIE_NAME);
    return 'cleared';
  }

  return 'none';
};

export const useMobilePreviewOverride = (): void => {
  useEffect(() => {
    const result = applyMobilePreviewOverride(window.location.search);
    if (result === 'none') return;

    const url = new URL(window.location.href);
    url.searchParams.delete(PARAM_NAME);
    window.location.replace(url.toString());
  }, []);
};
